<template>

</template>

<script>
	export default {
		props: ['data'],
		data() {
			return {
				checkboxIsClicked: false
			}
		},
		mounted() {
			if (this.$refs['cookie-check']) {
				let cookieName = this.$refs['cookie-check'].name;
				if (this.$cookies.isKey(cookieName) || this.$cookies.isKey(cookieName + '_once')) {
					this.close();
				}
			}
		},
		methods: {
			close() {
				if (this.$refs['cookie-check'] && this.$refs['cookie-check'].checked) {
					let cookieName = this.$refs['cookie-check'].name;
					this.$cookies.set(cookieName, true, 60 * 60 * 24 * 30);
				}
				this.$root.$emit('close-popup', this);
			},
			checkboxClicked() {
				this.checkboxIsClicked = !this.checkboxIsClicked;
			},
			dontShowAnymore() {
				let cookieName = this.$refs['cookie-check'].name;
				this.$cookies.set(cookieName, true, 60 * 60 * 24 * 30);
				this.close();
			},
			showCustom(days = 1) {
				let cookieNameOnce = this.$refs['cookie-check'].name + '_once';
				if (!this.checkboxIsClicked) {
					this.$cookies.set(cookieNameOnce, true, 60 * 60 * 24 * days);
				}
				this.close();
			}
		}
	}
</script>
